<template>
    <modal name="live-class-member-list-modal" class="popup-banner-modal"
           :width="'500px'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="list-content pa15">
            <div class="title pl25 pt20" style="display: inline-block;">수강생 등록</div>
            <div class="btn_wrap text-center mt20" style="display: inline-block; float: right;">
                <el-button class="mr25" type="cancel" @click="close()">닫기</el-button>
            </div>
            <div class="pl30 pr30 pb15 pt30">
                <member-list-component :memberType="`memberLiveClassModal`" :streamingKey="streamingKey"></member-list-component>
            </div>
        </div>
    </modal>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import MemberListComponent from "@/components/member/MemberListComponent";
import util from "@/mixins/util";

export default {
    name: "LiveClassMemberListModal",
    mixins: [alertMixins],
    components: {
        MemberListComponent,
    },
    props: {},
    inject: [],
    provide() {
        return {
        }
    },
    data() {
        return {
            streamingKey: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            let params = event.params;
            if (!util.isEmpty(params) && !util.isEmpty(params.streamingKey)) {
                this.streamingKey = params.streamingKey;
            }
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
        },
        close() {
            this.$modal.hide('live-class-member-list-modal');
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
